import { gql } from "@apollo/client";

export const GET_DOCUMENT_REPOSITORY = gql`
  query documentRepository($params: DocumentRepositoryListInput) {
    documentRepository(params: $params) {
      items {
        id
        fileName
        fileDisplayName
        fileSizeInBytes
        fileMimeType
        filePath
        fileChecksum
        documentDescription
        documentTypeId
        documentType
        documentTypeKey
        purchaserId
        purchaserName
        purchaserKey
        createdBy
        uploadedByName
        createdAt
        initiatedAt
        processedAt
        source
        parentId
      }
      total
      page
      limit
    }
  }
`;
